import React, { FC } from 'react';
import { ButtonLinkWithIcon, Text } from '@blueprint/ui';
import {
    ProfileMenuWrapper,
    ProfileWrapper,
    AccountMenuWrapper,
    StyledLogoIcon,
    SignedInLink,
    SignInLink,
    SavedLink,
    MyHomeLink
} from './ProfileMenu.styles';
import AccountMenu from '../AccountMenu';
import { SaveOutlineSmall, UserSmall, PropertiesSmall } from '@blueprint/icons';

type Props = {
    signInUrl: string;
};

const ProfileMenu: FC<Props> = ({ signInUrl }) => (
    <ProfileMenuWrapper>
        <ProfileWrapper data-testid="header-profile">
            <MyHomeLink>
                <ButtonLinkWithIcon
                    href="/home-values/"
                    variant="tertiary"
                    data-testid="header-profilemenu-my-home"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>my home"
                    data-myhome-button
                >
                    <div>
                        <PropertiesSmall width="20" height="20" />
                        <Text>My Home</Text>
                    </div>
                </ButtonLinkWithIcon>
            </MyHomeLink>
            <SavedLink data-is-logged-in="false">
                <ButtonLinkWithIcon
                    href="/signin/?page_after_login=/myaccount/favourites/&return_url=/myaccount/favourites/"
                    variant="tertiary"
                    data-testid="header-profilemenu-favourites"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>favourite properties>logged out"
                >
                    <div>
                        <SaveOutlineSmall width="20" height="20" />
                        <Text>Saved</Text>
                    </div>
                </ButtonLinkWithIcon>
            </SavedLink>
            <SavedLink data-is-logged-in="true">
                <ButtonLinkWithIcon
                    href="/myaccount/favourites/"
                    variant="tertiary"
                    data-testid="header-profilemenu-favourites"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>favourite properties"
                >
                    <div>
                        <SaveOutlineSmall width="20" height="20" />
                        <Text>Saved</Text>
                    </div>
                </ButtonLinkWithIcon>
            </SavedLink>
            <SignInLink data-is-logged-in="false">
                <ButtonLinkWithIcon
                    href={signInUrl}
                    variant="tertiary"
                    data-testid="header-profile-sign-in"
                    data-header-signin="/signin/?page_after_login={URL}&return_url={URL}"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>sign in"
                >
                    <div>
                        <UserSmall width="20" height="20" />
                        <Text>Sign in</Text>
                    </div>
                </ButtonLinkWithIcon>
            </SignInLink>
            <SignedInLink data-is-logged-in="true">
                <ButtonLinkWithIcon
                    href="/myaccount/"
                    variant="tertiary"
                    data-testid="header-profile-account"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account"
                >
                    <div>
                        <StyledLogoIcon />
                        <Text>My Zoopla</Text>
                    </div>
                </ButtonLinkWithIcon>
                <AccountMenuWrapper>
                    <AccountMenu />
                </AccountMenuWrapper>
            </SignedInLink>
        </ProfileWrapper>
    </ProfileMenuWrapper>
);

export default ProfileMenu;
